import type { ReactNode } from 'react';

type IconProps = { className?: string };

function iconWrap(children: ReactNode, className = 'h-4 w-4') {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );
}

export function ActivityFeedIconEye({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </>,
    className
  );
}

export function ActivityFeedIconClock({ className }: IconProps) {
  return iconWrap(
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </>,
    className
  );
}

export function ActivityFeedIconHeart({ className }: IconProps) {
  return iconWrap(
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />,
    className
  );
}

export function ActivityFeedIconPlay({ className }: IconProps) {
  return iconWrap(
    <>
      <polygon points="6 3 20 12 6 21 6 3" />
    </>,
    className
  );
}

export function ActivityFeedIconMessage({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </>,
    className
  );
}

export function ActivityFeedIconCalendar({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
    </>,
    className
  );
}

export function ActivityFeedIconUserPlus({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <line x1="19" x2="19" y1="8" y2="14" />
      <line x1="22" x2="16" y1="11" y2="11" />
    </>,
    className
  );
}

export function ActivityFeedIconSparkles({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z" />
    </>,
    className
  );
}

export function ActivityFeedIconFile({ className }: IconProps) {
  return iconWrap(
    <>
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    </>,
    className
  );
}

export function ActivityFeedIconChevronLeft({ className }: IconProps) {
  return iconWrap(<path d="m15 18-6-6 6-6" />, className);
}

export function ActivityFeedIconChevronRight({ className }: IconProps) {
  return iconWrap(<path d="m9 18 6-6-6-6" />, className);
}
